function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourceWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.24,45.75c7.16,0,13-4.61,13-10.29,0-4.39-3.47-8.13-8.34-9.61-.17-4.23-3.2-7.61-6.92-7.61a6,6,0,0,0-1.85.3,13.83,13.83,0,0,0-12.76-7.73c-7.6,0-13.77,5.53-13.77,12.36a12.64,12.64,0,0,0,.11,1.52c-6.26.53-11.14,5-11.14,10.5,0,5.84,5.55,10.56,12.4,10.56Z",
    style: {
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.92,16.72a8.2,8.2,0,0,0-8.08,8.33",
    style: {
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.25,58.28c2.54,3,7.91,5.33,12.87,1.17s3.62-9.86,1.08-12.89c-4.41-5.25-17.47-6.64-17.47-6.64S44.83,53,49.25,58.28Z",
    style: {
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66,57.4a5,5,0,0,0,3-3,5.08,5.08,0,0,0,0-4.26",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.22,71.47a6.44,6.44,0,1,0,9.86-8.28c-3.11-3.72-12.34-4.7-12.34-4.7S36.1,67.75,39.22,71.47Z",
    style: {
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.87,70.84A3.51,3.51,0,0,0,48,68.71a3.58,3.58,0,0,0,0-3",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.91,52.75a6.44,6.44,0,1,0,9.86-8.28c-3.12-3.72-12.35-4.7-12.35-4.7S26.79,49,29.91,52.75Z",
    style: {
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.56,52.12A3.51,3.51,0,0,0,38.65,50a3.58,3.58,0,0,0,0-3",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.3px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceWater);
export default __webpack_public_path__ + "static/media/source_water.cdf5929c545ad907500f5aed33e8f669.svg";
export { ForwardRef as ReactComponent };